import React, { useState, useEffect } from 'react';
import { Container, Badge } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import moment from 'moment';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const NewsDetail = () => {
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, [slug]);

  const loadNews = async () => {
    try {
      const response = await api.get(`/news/${slug}/`);
      setNews(response.data);
    } catch (error) {
      console.error('Error loading news:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!news) {
    return (
      <Container className="py-5">
        <h1>News Not Found</h1>
        <Link to="/news" className="btn btn-primary">Back to News</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <article>
        <h1>{news.title}</h1>
        <div className="mb-3">
          <Badge bg="primary" className="me-2">
            {moment(news.published_date).format('MMMM DD, YYYY')}
          </Badge>
          {news.is_featured && <Badge bg="success">Featured</Badge>}
        </div>
        {news.featured_image && (
          <img 
            src={getMediaUrl(news.featured_image)} 
            alt={news.title}
            className="img-fluid mb-4 rounded"
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: news.content }} />
      </article>
      <div className="mt-4">
        <Link to="/news" className="btn btn-outline-primary">← Back to News</Link>
      </div>
    </Container>
  );
};

export default NewsDetail;
